"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'autocomplete.triggers.suggestions': '可用项目',
    'autocomplete.triggers.noResults': '未找到匹配项',
    'autocomplete.triggers.stylesPlaceholder': '输入 / 搜索样式...',
    'autocomplete.triggers.projectsPlaceholder': '输入 # 搜索项目...',
    'autocomplete.triggers.knowledgePlaceholder': '输入 @ 搜索知识...',
    'autocomplete.triggers.loading': '加载中...',
    'autocomplete.triggers.error': '加载建议时出错',
};
